import { render, staticRenderFns } from "./TabelaProcessos.vue?vue&type=template&id=3aeee92f&scoped=true&"
import script from "./TabelaProcessos.vue?vue&type=script&lang=js&"
export * from "./TabelaProcessos.vue?vue&type=script&lang=js&"
import style0 from "./TabelaProcessos.vue?vue&type=style&index=0&id=3aeee92f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aeee92f",
  null
  
)

export default component.exports